import React from 'react';
import styled from 'styled-components';
import deleteCloseIcon from '../../../asset/icon/delete_close.png';
import deleteOpenIcon from '../../../asset/icon/delete_open.png';
import UniversalIconBtn from '../../../shared/component/headless/button/UniversalIconBtn';
import { getAlertMessage } from '../../../shared/constants/alertMessages';
import { AlertPosition, AlertType } from '../../../shared/enum/EnumRepository';
import { useStandardAlertStore } from '../../../shared/store/portal/alertStore';
import { useAdminExhibition } from '../../share/hook/useAdminExhibition';

const MultiExhibitionViewer: React.FC = () => {
  const {
    multiSelectedExhibitionIds,
    removeSelectedExhibitions,
  } = useAdminExhibition();
  const enqueueAlert = useStandardAlertStore((state) => state.enqueueAlert);

  if (multiSelectedExhibitionIds.length < 2) return null;

  const handleDelete = () => {
    enqueueAlert({
      type: AlertType.CONFIRM,
      position: AlertPosition.TOP,
      content: getAlertMessage('CONFIRM_DELETE_EXHIBITIONS_BULK', {
        count: multiSelectedExhibitionIds.length,
      }),
      callBack: async () => {
        await removeSelectedExhibitions();
      },
    });
  };

  return (
    <ViewerContainer>
      <Title>{multiSelectedExhibitionIds.length} exhibitions selected</Title>
      <ActionBar>
        <UniversalIconBtn
          aria-label="Delete selected exhibitions"
          size="fit"
          border={true}
          backgroundImg={deleteCloseIcon}
          backgroundImgHover={deleteOpenIcon}
          onClick={handleDelete}
        />
      </ActionBar>
    </ViewerContainer>
  );
};

const ViewerContainer = styled.section`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const Title = styled.h2`
  width: 100%;
  min-height: 28px;
  margin: 0 0 10px;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.color_Gray_03};
  ${({ theme }) => theme.typography.Body_02_1};
`;

const ActionBar = styled.div`
  position: absolute;
  right: 0;
  bottom: 0.6vh;
  z-index: 1;
  display: flex;
  align-items: center;
`;

export default MultiExhibitionViewer;
